export let menuConfig = [
    {
        title: 'Trading screen',
        path: 'onlinemarkets',
        submenu: []
    },
    {
        title: 'Your details',
        action: 'SHOW_USER_POPUP',
        submenu: []
    },
    {
        title: 'Orders',
        path: 'yourworkingorders',
        submenu: [
            {
                title: 'Your working orders',
                path: 'yourworkingorders'
            },
            {
                title: 'Your open positions',
                path: 'youropenpositions'
            },
            {
                title: 'Your settled trades',
                path: 'yoursettledtrades'
            },
            {
                title: 'Last traded',
                path: 'lasttraded',
                requires: 'superuser'
            }

        ]
    },
    {
        title: 'Manage',
        path: 'managecompanies',
        requires: ['superuser','admin'],
        submenu: [
            {
                title: 'Tabs',
                path: 'managetabs',
            },
            {
                title: 'Companies',
                path: 'managecompanies'
            },
            {
                title: 'Markets',
                path: 'managemarkets'
            },
            {
                title: 'Freights',
                path: 'managedischarge'
            },
            {
                title: 'Counter party filter',
                path: 'managecounterparty'
            },
            {
                title: 'Indices schedule',
                path: 'manageindicesschedule'
            },
            {
                title: 'Indices',
                path: 'manageindices'
            },
            {
                title: 'Notifications',
                path: 'managenotifications'
            }            
        ]
    },
    {
        title: 'Active users',
        path: 'activeusers',
        requires: 'superuser',
    },
    {
        title: 'Logs',
        path: 'systemlog',
        requires: ['superuser','admin'],
        submenu: [
            {
                title: 'System log',
                path: 'systemlog',
                requires: ['superuser','admin'],
            },
            {
                title: 'Order log',
                path: 'transactionlog',
                requires: ['superuser','admin'],
            }
        ],
    }
];



// WEBPACK FOOTER //
// ./source/config/menubottomconfig.js